<style lang="scss" scoped>
.stats {
	border-bottom: 1px solid #eee;
	padding: 20px 40px;
	@include flex-center;
	&__item {
		width: 100%;
		cursor: pointer;
	}
	&__number {
		font-weight: 600;
		font-size: 30px;
		color: #303144;
	}
}
</style>
<template lang="pug">
    .stats
        .stats__item(v-if="providerCode !== 'apl'" @click="$bus.emit('filter-set', 'matched')")
            .stats__number {{ matched }}
            .stats__description Matched users
        .stats__item(v-if="features.sync" @click="$bus.emit('filter-set', 'unmatched')")
            .stats__number {{ unmatched }}
            .stats__description {{ providerCode == 'apl' ? "Unignored users": "Unmatched users" }}
        .stats__item(v-if="features.sync" @click="$bus.emit('filter-set', 'skipped')")
            .stats__number {{ skipped }}
            .stats__description Ignored users
        .stats__item(v-if="features.sync" @click="$bus.emit('filter-set', 'suspended')")
            .stats__number {{ suspended }}
            .stats__description Suspended users
        .stats__item(v-if="features.sync" @click="$bus.emit('filter-set', 'leaver')")
            .stats__number {{ leavers }}
            .stats__description Leavers
        .stats__item(@click="$bus.emit('filter-set', 'none')")
            .stats__number {{ total }}
            .stats__description Total users
</template>
<script>
import _ from "lodash";
export default {
	props: ["results"],

	computed: {
		total() {
			return this.results.length;
		},
		matched() {
			return _.filter(this.results, r => r.status && ["matched", "created"].includes(r.status)).length;
		},
		unmatched() {
			return _.filter(this.results, r => !r.status || r.status == "unmatched").length;
		},
		skipped() {
			return _.filter(this.results, r => r.status && r.status == "skipped").length;
		},
		suspended() {
			return _.filter(this.results, r => r.status && r.status == "suspended").length;
		},
		leavers() {
			return _.filter(this.results, r => r.status && ["marked_for_suspension", "marked_for_deletion", "leaver"].includes(r.status)).length;
		}
	}
};
</script>

